function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.33 26c-.65 0-1.2-.23-1.65-.68-.45-.45-.68-1-.68-1.65V6.33c0-.65.23-1.2.68-1.65S5.68 4 6.33 4h7.21a.96.96 0 0 1 .97.97c0 .28-.1.51-.29.69a.97.97 0 0 1-.68.28H6.33c-.09 0-.17.04-.26.13s-.13.17-.13.26v17.34c0 .09.04.17.13.26s.17.13.26.13h17.34c.09 0 .17-.04.26-.13s.13-.17.13-.26v-7.21a.96.96 0 0 1 .97-.97.96.96 0 0 1 .97.97v7.21c0 .65-.23 1.2-.68 1.65-.45.45-1 .68-1.65.68H6.33Zm5.05-7.38c-.19-.17-.29-.39-.29-.66s.1-.5.29-.69L22.7 5.94h-4.14c-.28 0-.51-.09-.69-.28-.18-.18-.28-.41-.28-.69a.942.942 0 0 1 .97-.97h6.28c.32 0 .6.11.83.34.23.23.34.5.34.83v6.28c0 .28-.09.51-.27.69-.18.18-.42.28-.7.28a.942.942 0 0 1-.97-.97V7.3L12.71 18.66c-.17.19-.39.29-.65.29s-.49-.11-.68-.32Z",
    style: {
      fill: "#1c1b1f"
    }
  }));
};

export default SvgExternalLink;